import React from 'react';

import {
  createInstance,
  OptimizelyProvider as Provider,
  ReactSDKClient
} from '@optimizely/react-sdk';

import environmentStore from 'src/stores/EnvironmentStore';
import { OptimizelyFlagContext } from './hooks/useOptimizelyFlag';

let optimizely: ReactSDKClient | null = null;

const getOptimizelyClient = () => {
  if (!optimizely) {
    optimizely = createInstance({
      sdkKey: process.env.REACT_APP_OPTIMIZELY_SDK_KEY
    });
  }

  return optimizely;
};

interface OptimizelyProviderProps {
  children: React.ReactNode;
}

export const OptimizelyProvider = ({ children }: OptimizelyProviderProps) => {
  const optimizelyState = environmentStore.optimizelyState;

  if (!optimizelyState) {
    return children;
  }

  return (
    <Provider optimizely={getOptimizelyClient()} user={optimizelyState.user}>
      <OptimizelyFlagContext.Provider value={optimizelyState.flags}>
        {children}
      </OptimizelyFlagContext.Provider>
    </Provider>
  );
};
